import { Component } from "@angular/core";

@Component({
    selector: "pl-home",
    templateUrl: "./home.component.html",
    standalone: false
})
export class HomePageComponent {}
